(function () {
  window.userService = {
    login(data) {
      return axios.post(`/api/user/login.php`, {
        email: data.email,
        password: data.password,
      });
    },
    logout() {
      return axios.get(`/api/user/logout.php`);
    },
    get(data) {
      return axios.get(
        `/api/user/get.php?twitchId=${
          data ? data.userId : utils.cookies.get('user_id')
        }`
      );
    },
    create() {
      return axios.post('/api/user/create.php', {
        twitchId: utils.cookies.get('user_id'),
        twitchLogin: utils.cookies.get('user_login'),
        twitchDisplayName: utils.cookies.get('user_display_name'),
        twitchEmail: utils.cookies.get('user_email'),
        twitchProfileImage: utils.cookies.get('user_profile_image'),
      });
    },
    update() {
      return axios.post('/api/user/update.php', {
        twitchId: utils.cookies.get('user_id'),
        twitchLogin: utils.cookies.get('user_login'),
        twitchDisplayName: utils.cookies.get('user_display_name'),
        twitchEmail: utils.cookies.get('user_email'),
        twitchProfileImage: utils.cookies.get('user_profile_image'),
        theme: utils.cookies.get('theme'),
      });
    },
    getToken(data) {
      return axios.post('/api/token/get.php', {
        redirectUrl: data.redirectUrl,
        code: data.code,
      });
    },
    refreshToken() {
      return axios.post('/api/token/validate.php', {});
    },
    search(data) {
      return axios.post('/api/user/search.php', {
        twitchDisplayName: data.twitchDisplayName,
      });
    },
    searchStreamers(data) {
      return axios.post('/api/user/search.php', {
        twitchDisplayName: data.twitchDisplayName,
        streamersOnly: true,
      });
    },
    stats() {
      return axios.get(
        `/api/user/stats.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    useSpecialCard(data) {
      return axios.post('/api/user/specialcard/active.php', {
        twitchId: data.fromId,
      });
    },
    getCards(data) {
      return axios.get(
        `/api/user/card/get.php?twitchId=${data.twitchId}&unlockQueueId=${data.id}`
      );
    },
    getKeys() {
      return axios.get(
        `/api/user/key/get.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    getDogTags() {
      return axios.get(
        `/api/user/tags/get.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    saveCards(data) {
      return axios.post('/api/user/card/save.php', {
        twitchId: data.twitchId,
        unlockQueueId: data.unlockQueueId,
        cardId: data.cardId,
        tier: data.tier,
        value: data.value,
        deltaCard: data.deltaCard || false,
      });
    },
    unlockedCards() {
      return axios.get(
        `/api/user/card/unlocked.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    getLegacyCards(page = 1, limit = 18) {
      return axios.get(
        `/api/user/card/legacy.php?twitchId=${utils.cookies.get('user_id')}&page=${page}&limit=${limit}`
      );
    },
    addRemoveToFavorites(data){
      return axios.post('/api/user/card/add_to_favorites.php', {
        twitchId: data.twitchId,
        cardNumber: data.cardNumber,
        addRemove: data.add,
        dateCreated: data.dateCreated,
      });
    },
    getFavorites(){
      return axios.get(
        `/api/user/card/favorites.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    equipBoneCard(data){
      return axios.post('/api/user/card/equip_bone.php', {
       twitchId: data.twitchId,
       cardNumber: data.card, 
       boneCardId: data.boneCardId, 
       boneId: data.boneId, 
       dateCreated: data.dateCreated, 

      });
    },
    equipDeltaCard(data) {
      return axios.post('/api/user/card/equip_delta.php', {
        twitchId: data.twitchId,
        cardNumber: data.cardNumber,
        deltaCardId: data.deltaCardId,
        userDeltaCardId: data.userDeltaCardId,
      });
    },
    unequipDeltaCard(data) {
      return axios.post('/api/user/card/unequip_delta.php', {
        twitchId: data.twitchId,
        cardNumber: data.cardNumber,
      });
    },
    getBoneCards(){
      return axios.get(
        `/api/user/card/bone.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    verifyCards(data) {
      let cards = data.cards;
      cards = cards.join('-');
      cards = cards.replace(/#/g, '');

      if(data.option){
        return axios.get(
          `/api/user/card/verify.php?twitchId=${data.twitchId}&cards=${cards}&status=${data.status}&option=${data.option}`
        );
      }
      else{
        return axios.get(
          `/api/user/card/verify.php?twitchId=${data.twitchId}&cards=${cards}&status=${data.status}`
        );
      }
      
    },
    getLeaderboard(config) {
      return axios.get(`/api/leaderboard/get.php`,config);
    },
    getTeamLeaderboard() {
      return axios.get(`/api/leaderboard/team/get.php`);
    },
    getLeaderboardFaction(id){
      return axios.get(`/api/leaderboard/faction/get.php?fid=${id}`);
    },
    getTeams(data) {
      return axios.get(
        `/api/user/team/get.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    getLegacyTeams(data) {
      return axios.get(
        `/api/user/team/get-legacy.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    getStreamersLeaderboard(){
      return axios.get(`/api/leaderboard/streamers/get.php`);
    },
    getValidTeams(data){
    
      return axios.post('/api/user/validate.php', data);
    },
    saveTeam(data) {
      data.twitchId = utils.cookies.get('user_id');
      return axios.post('/api/user/team/save.php', data);
    },
    deleteTeam(data) {
      data.twitchId = utils.cookies.get('user_id');
      return axios.post('/api/user/team/delete.php', data);
    },
    addMod(data) {
      return axios.post('/api/user/streamermod.php', data);
    },
    removeMod(data){
      return axios.post('/api/user/streamermod.php', data);
    },
    addStreamer(data) {
      return axios.post('/api/user/streamer.php', data);
    },
    removeStreamer(data){
    return axios.post('/api/user/streamermod.php', data);
    },
    getStreamerBattleState(config) {
      return axios.get(
        `/api/streamer/get1.php?state=true&&twitchId=${utils.cookies.get(
          'user_id'
        )}`,config
      );
    },
    saveStreamteam(data){
      data.twitchId = utils.cookies.get('user_id');
      return axios.post('/api/streamer/save.php', data);
    },
    getSteamerQueue() {
      return axios.get(
        `/api/streamer/get-queue.php?streamerTwitchId=${utils.cookies.get(
          'user_id'
        )}`
      );
    },
    toggleStreamerBattle(data) {
      data.twitchId = utils.cookies.get('user_id');
      return axios.post('/api/user/streamer-battle-active.php', data);
    },
    joinStreamerTeamQueue(data) {
      return axios.post('/api/streamer/join-queue.php', data);
    },
    leaveStreamerTeamQueue(data) {
      return axios.post('/api/streamer/leave-queue.php', data);
    },
    cancelStreamPlayer(data){
      return axios.post('/api/streamer/leave.php', data);
    },
    declineUserTeam(data) {
      return axios.post('/api/streamer/cancel.php', data);
    },
    acceptUserTeam(data) {
      return axios.post('/api/streamer/join.php', data);
    },
    getTeamCardInfo(data){
      data.twitchId = utils.cookies.get('user_id');
      return axios.post('/api/user/team/get-team-stats.php', data);
    },
    getUserBark(id){
      return axios.get(
        `/api/user/barks/get.php?twitchId=${utils.cookies.get(
          'user_id'
        )}`
      );
    },
    getAscension(){
      return axios.get(
        `/api/user/card/ascnension.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    getDeltaCards(){
      return axios.get(
        `/api/user/card/delta.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    getExoticCards(){
      return axios.get(
        `/api/user/card/exotic.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    getInventory(){
      return axios.get(
        `/api/user/card/inventory.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    openJewelryF(data){
      data.active = true;
      return axios.post('/api/store/save.php', data);
    },
    upgradeTier(data){

      return axios.post('/api/user/card/upgrade_tier.php', data);
    },
    exaltCard(data){
      return axios.post('/api/user/card/exalt.php', data);
    },
    userStoreActive(data){
      return axios.post('/api/store/save.php', data);
    },
    spiritForge(data){
      return axios.post('/api/store/save.php', data);
    },
    getStats(){
      return axios.get(
      `/api/user/stats/get.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    getStreamerTimer(){
      return axios.get(
      `/api/streamer/get.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    getStreamerTeam(config){
      return axios.get(
      `/api/streamer/get1.php?team=true&&twitchId=${utils.cookies.get('user_id')}`,config
      )
    },
    joinTournament(data){
      return axios.post('/api/tournament/join.php', data);
    },
    joinTeamTournament(data){
      return axios.post('/api/tournament/team/join.php', data);
    },
    enableStreamerFaction(data){
      return axios.post(`/api/user/streamer/save.php`, {
        id: data.id,
        twitchId: utils.cookies.get('user_id'),
        faction: data.faction
       });
    },
    getUserLevel(data){
      return axios.get(`/api/user/level/get.php?twitchId=${utils.cookies.get('user_id')}` );
    },
    getStreamersCommunityLeaderboardSingle(id){
      return axios.get(`/api/leaderboard/streamers/get.php?twitchId=${id}&&t=single`);
    },
    getStreamersCommunityLeaderboardTeam(id){
      return axios.get(`/api/leaderboard/streamers/get.php?twitchId=${id}&&t=team`);
    },
    getSeasonSingle(){
      return axios.get(`/api/leaderboard/seasonal/get.php?t=single`);
    },
    getSeasonTeam(){
      return axios.get(`/api/leaderboard/seasonal/get.php?t=team`);
    },
    getSelectedTeamLeaderboard(data){
      return axios.get(`/api/leaderboard/team/get.php?t=${data}`);
    },
    getModLogs(data){
      return axios.get(`/api/user/logs/get.php?twitchId=${utils.cookies.get('user_id')}&page=${data.page}&limit=${data.limit}`, data.cancelToken );
    },
    reconstructReward(data){
      data.twitchId = utils.cookies.get('user_id');
      return axios.post('/api/user/rewards/save.php', data);
    },
    getUserEventQueue(){
      return axios.get(
        `/api/events/queue/get.php?twitchId=${utils.cookies.get(
          'user_id'
        )}`
      );
    },
    saveUserReward(){
      data.twitchId = utils.cookies.get('user_id');
      return axios.post('/api/user/rewards/save.php', data);
    },
    getUserDetails(id){
       return axios.get(`/api/user/get.php?twitchId=${id}`);
    }
  
  };
})();
